import React from 'react';
import { useSidebar } from '../contexts/SidebarContext';

const MainContent = ({ children, className = '' }) => {
  const { isCollapsed } = useSidebar();
  
  return (
    <div 
      className={`main-content ${className}`}
      style={{ 
        marginLeft: isCollapsed ? '80px' : '256px',
        transition: 'margin-left 0.3s ease'
      }}
    >
      {children}
    </div>
  );
};

export default MainContent;

